(function () {
  'use strict';

  var QUESTION_COUNT = 11;
  var SAVE_DELAY = 800;
  var LEGACY_ATTRIBUTE_KEYS = [
    'Eligibility Attestations Agreed',
    'Eligibility Attestations Version',
    'Eligibility Attestations Items',
    'Eligibility Attestations Timestamp',
    'Eligibility Attestations Modal Opened'
  ];

  function initCartQuestionnaire() {
    var cartPage = document.querySelector('[data-cart-page]');
    if (!cartPage || cartPage.dataset.baQuestionnaireReady === 'true') return;

    cartPage.dataset.baQuestionnaireReady = 'true';

    var cartForm = cartPage.querySelector('[data-cart-form]');
    var questionnaire = cartPage.querySelector('[data-ba-questionnaire]');
    var healthPanel = cartPage.querySelector('[data-ba-health-panel]');
    var checkoutWrapper = cartPage.querySelector('[data-cart-checkout-buttons]');
    var checkoutFieldset = cartPage.querySelector('[data-cart-checkout-button]');
    var primaryCheckout = cartPage.querySelector('[data-primary-checkout]');
    var termsCheckbox = cartPage.querySelector('#acceptance');
    var cancellationCheckbox = cartPage.querySelector('#ba_cancel_accept');
    var checkoutMessage = cartPage.querySelector('[data-terms-error-message]');
    var isSaving = false;
    var saveTimer = null;
    var saveQueue = Promise.resolve();
    var currentStep = '1';
    var opener = null;

    var questions = questionnaire ? Array.prototype.slice.call(questionnaire.querySelectorAll('[data-ba-question]')) : [];
    var steps = questionnaire ? Array.prototype.slice.call(questionnaire.querySelectorAll('[data-ba-step]')) : [];
    var openButtons = cartPage.querySelectorAll('[data-ba-questionnaire-open]');
    var closeButton = questionnaire ? questionnaire.querySelector('[data-ba-questionnaire-close]') : null;
    var questionnaireBody = questionnaire ? questionnaire.querySelector('[data-ba-questionnaire-body]') : null;
    var backButton = questionnaire ? questionnaire.querySelector('[data-ba-questionnaire-back]') : null;
    var nextButton = questionnaire ? questionnaire.querySelector('[data-ba-questionnaire-next]') : null;
    var finishButton = questionnaire ? questionnaire.querySelector('[data-ba-questionnaire-finish]') : null;
    var progress = questionnaire ? questionnaire.querySelector('[data-ba-progress]') : null;
    var progressLabel = questionnaire ? questionnaire.querySelector('[data-ba-progress-label]') : null;
    var progressCount = questionnaire ? questionnaire.querySelector('[data-ba-progress-count]') : null;
    var questionnaireError = questionnaire ? questionnaire.querySelector('[data-ba-questionnaire-error]') : null;
    var saveStatus = questionnaire ? questionnaire.querySelector('[data-ba-save-status]') : null;
    var panelStatus = healthPanel ? healthPanel.querySelector('[data-ba-panel-status]') : null;
    var completedInput = cartPage.querySelector('[data-ba-completed]');
    var requiresReviewInput = cartPage.querySelector('[data-ba-requires-review]');
    var timestampInput = cartPage.querySelector('[data-ba-timestamp]');

    function routesRoot() {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      return root || '/';
    }

    function cartUpdateUrl() {
      return routesRoot() + 'cart/update.js';
    }

    function checkoutUrl() {
      return routesRoot() + 'checkout';
    }

    function getAttributeKey(input) {
      var match = input.name && input.name.match(/^attributes\[(.+)\]$/);
      return match ? match[1] : '';
    }

    function checkedAnswer(question) {
      var checked = question.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : '';
    }

    function detailsInput(question) {
      return question.querySelector('[data-ba-explanation]');
    }

    function medicationsInput(question) {
      return question.querySelector('[data-ba-medications]');
    }

    function questionIsValid(question) {
      var answer = checkedAnswer(question);
      if (!answer) return false;
      if (answer === 'Yes') {
        var details = detailsInput(question);
        return !!details && details.value.trim().length > 0;
      }
      return true;
    }

    function answeredCount() {
      return questions.filter(function (question) {
        return !!checkedAnswer(question);
      }).length;
    }

    function hasYesAnswers() {
      return questions.some(function (question) {
        return checkedAnswer(question) === 'Yes';
      });
    }

    function allQuestionsValid() {
      return questions.length === QUESTION_COUNT && questions.every(questionIsValid);
    }

    function questionnaireIsRequired() {
      if (!questionnaire || !healthPanel) return false;
      var markedItems = cartPage.querySelectorAll('[data-cart-item][data-requires-tier-questionnaire="true"]');
      return markedItems.length > 0 || healthPanel.dataset.forceRequirement === 'true';
    }

    function questionnaireIsCompleted() {
      if (!questionnaireIsRequired()) return true;
      return allQuestionsValid() && completedInput && completedInput.value === 'Yes' && timestampInput && !!timestampInput.value;
    }

    function termsAreAccepted() {
      return !termsCheckbox || termsCheckbox.checked;
    }

    function cancellationIsAccepted() {
      return !cancellationCheckbox || cancellationCheckbox.checked;
    }

    function checkoutIsAllowed() {
      return termsAreAccepted() && cancellationIsAccepted() && questionnaireIsCompleted() && !isSaving;
    }

    function setCheckoutMessage() {
      if (!checkoutMessage) return;

      var missing = [];
      if (!termsAreAccepted()) missing.push('Terms & Conditions');
      if (!cancellationIsAccepted()) missing.push('Cancellation & Billing Policy');
      if (!questionnaireIsCompleted()) missing.push('the health questionnaire');

      checkoutMessage.textContent = missing.length ? 'Please complete: ' + missing.join(', ') + ' to continue.' : '';
      checkoutMessage.classList.toggle('is-expanded', missing.length > 0);
    }

    function setAdditionalCheckoutState(enabled) {
      var controls = cartPage.querySelectorAll('.additional-checkout-buttons button, .additional-checkout-buttons a, .shopify-payment-button__button');
      controls.forEach(function (control) {
        control.setAttribute('aria-disabled', enabled ? 'false' : 'true');
        if ('disabled' in control) control.disabled = !enabled;
        if (enabled) {
          control.removeAttribute('tabindex');
        } else {
          control.setAttribute('tabindex', '-1');
        }
      });
    }

    function updateCheckoutState() {
      var allowed = checkoutIsAllowed();

      if (checkoutWrapper) checkoutWrapper.classList.toggle('cart__buttons--disabled', !allowed);
      if (checkoutFieldset) checkoutFieldset.disabled = !allowed;
      if (primaryCheckout) primaryCheckout.disabled = !allowed;
      setAdditionalCheckoutState(allowed);
      setCheckoutMessage();
      updatePanelStatus();
    }

    function setQuestionDetailsState(question) {
      var answer = checkedAnswer(question);
      var detailsWrap = question.querySelector('[data-ba-details]');
      var details = detailsInput(question);
      var medications = medicationsInput(question);
      var shouldShow = answer === 'Yes';

      if (detailsWrap) detailsWrap.hidden = !shouldShow;
      if (details) {
        details.required = shouldShow;
        details.setAttribute('aria-required', shouldShow ? 'true' : 'false');
        if (!shouldShow) {
          details.value = '';
          details.removeAttribute('aria-invalid');
        }
      }
      if (!shouldShow && medications) medications.value = '';
    }

    function updateProgress() {
      if (!questionnaire) return;
      var count = answeredCount();
      if (progress) {
        progress.value = count;
        progress.textContent = count + ' of ' + QUESTION_COUNT + ' answered';
      }
      if (progressCount) progressCount.textContent = count + ' of ' + QUESTION_COUNT + ' answered';
    }

    function updatePanelStatus() {
      if (!panelStatus || !questionnaireIsRequired()) return;

      if (questionnaireIsCompleted()) {
        panelStatus.textContent = hasYesAnswers()
          ? 'Complete — our team will review your answers and help with the best option.'
          : 'Complete.';
        healthPanel.classList.add('is-complete');
        var panelButton = healthPanel.querySelector('[data-ba-questionnaire-open]');
        if (panelButton) panelButton.textContent = 'Review answers';
      } else {
        panelStatus.textContent = answeredCount() + ' of ' + QUESTION_COUNT + ' completed';
        healthPanel.classList.remove('is-complete');
        var openButton = healthPanel.querySelector('[data-ba-questionnaire-open]');
        if (openButton) openButton.textContent = answeredCount() ? 'Continue' : 'Begin';
      }
    }

    function setError(message, focusTarget) {
      if (!questionnaireError) return;
      questionnaireError.textContent = message || '';
      questionnaireError.hidden = !message;
      if (message && focusTarget !== false) questionnaireError.focus();
    }

    function setSaveStatus(message, isError) {
      if (!saveStatus) return;
      saveStatus.textContent = message || '';
      saveStatus.classList.toggle('has-error', !!isError);
    }

    function setQuestionValidityUi(question, valid) {
      question.classList.toggle('has-error', !valid);
      var answer = checkedAnswer(question);
      var details = detailsInput(question);
      question.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        if (answer) {
          radio.removeAttribute('aria-invalid');
        } else {
          radio.setAttribute('aria-invalid', 'true');
        }
      });
      if (details) {
        if (answer === 'Yes' && !details.value.trim()) {
          details.setAttribute('aria-invalid', 'true');
        } else {
          details.removeAttribute('aria-invalid');
        }
      }
    }

    function validateQuestions(questionList, shouldFocus) {
      var invalid = questionList.filter(function (question) {
        var valid = questionIsValid(question);
        setQuestionValidityUi(question, valid);
        return !valid;
      });

      if (!invalid.length) {
        setError('', false);
        return true;
      }

      setError('Please answer every question on this step and add more information for each Yes answer.', false);
      if (shouldFocus) {
        var first = invalid[0];
        var answer = checkedAnswer(first);
        var focusTarget = answer === 'Yes' ? detailsInput(first) : first.querySelector('input[type="radio"]');
        if (focusTarget) focusTarget.focus();
      }
      return false;
    }

    function questionsForStep(stepNumber) {
      var step = questionnaire && questionnaire.querySelector('[data-ba-step="' + stepNumber + '"]');
      return step ? Array.prototype.slice.call(step.querySelectorAll('[data-ba-question]')) : [];
    }

    function firstIncompleteStep() {
      var invalid = questions.find(function (question) {
        return !questionIsValid(question);
      });
      var step = invalid && invalid.closest('[data-ba-step]');
      return step ? step.getAttribute('data-ba-step') : '1';
    }

    function showStep(stepName) {
      currentStep = String(stepName);
      steps.forEach(function (step) {
        step.hidden = step.getAttribute('data-ba-step') !== currentStep;
      });

      var isReview = currentStep === 'review';
      var numericStep = isReview ? 3 : parseInt(currentStep, 10);
      if (progressLabel) progressLabel.textContent = isReview ? 'Review your answers' : 'Step ' + numericStep + ' of 3';
      if (backButton) backButton.hidden = currentStep === '1';
      if (nextButton) nextButton.hidden = isReview;
      if (finishButton) finishButton.hidden = !isReview;
      setError('', false);
      if (questionnaireBody) questionnaireBody.scrollTop = 0;

      var activeStep = questionnaire.querySelector('[data-ba-step="' + currentStep + '"]');
      var focusTarget = activeStep && activeStep.querySelector('h3, legend, input');
      if (focusTarget && questionnaire.open) {
        if (!focusTarget.hasAttribute('tabindex') && focusTarget.tagName !== 'INPUT') focusTarget.setAttribute('tabindex', '-1');
        focusTarget.focus();
      }
    }

    function renderReview() {
      if (!questionnaire) return;
      var reviewList = questionnaire.querySelector('[data-ba-review-list]');
      var reviewMessage = questionnaire.querySelector('[data-ba-review-message]');
      if (!reviewList) return;
      reviewList.innerHTML = '';

      questions.forEach(function (question) {
        var item = document.createElement('li');
        var questionNumber = question.getAttribute('data-question-number');
        var answer = checkedAnswer(question);
        var details = detailsInput(question);
        var medications = medicationsInput(question);
        var questionLine = document.createElement('span');
        var answerLine = document.createElement('strong');
        var detailLine = document.createElement('p');

        var legend = question.querySelector('legend');
        questionLine.className = 'ba-questionnaire__review-question';
        questionLine.textContent = legend ? legend.textContent.trim() : 'Question ' + parseInt(questionNumber, 10);
        answerLine.textContent = 'Answer: ' + answer;
        item.appendChild(questionLine);
        item.appendChild(answerLine);
        if (answer === 'Yes' && details && details.value.trim()) {
          detailLine.textContent = details.value.trim();
          item.appendChild(detailLine);
        }
        if (answer === 'Yes' && medications && medications.value.trim()) {
          var medicationsLine = document.createElement('p');
          medicationsLine.className = 'ba-questionnaire__review-medications';
          medicationsLine.textContent = 'Medications or prescriptions: ' + medications.value.trim();
          item.appendChild(medicationsLine);
        }
        reviewList.appendChild(item);
      });

      if (reviewMessage) {
        reviewMessage.textContent = hasYesAnswers()
          ? 'Everything is complete. Any Yes answers will be reviewed so our team can help with the best available option.'
          : 'Everything is complete. Check your answers before saving.';
      }
    }

    function collectQuestionnaireAttributes() {
      var attributes = {};
      if (!questionnaire) return attributes;

      questionnaire.querySelectorAll('input[name^="attributes["], textarea[name^="attributes["]').forEach(function (input) {
        var key = getAttributeKey(input);
        if (!key) return;
        if (input.type === 'radio') {
          if (input.checked) attributes[key] = input.value;
          return;
        }
        attributes[key] = input.value;
      });

      cartPage.querySelectorAll('input[type="hidden"][name^="attributes[Eligibility Questionnaire"]').forEach(function (input) {
        var key = getAttributeKey(input);
        if (key) attributes[key] = input.value;
      });

      LEGACY_ATTRIBUTE_KEYS.forEach(function (key) {
        attributes[key] = '';
      });
      return attributes;
    }

    function collectCheckoutAttributes() {
      var attributes = collectQuestionnaireAttributes();
      if (cartForm) {
        cartForm.querySelectorAll('input[name^="attributes["], textarea[name^="attributes["], select[name^="attributes["]').forEach(function (input) {
          var key = getAttributeKey(input);
          if (!key) return;
          if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) return;
          attributes[key] = input.value;
        });
      }
      var termsAttribute = cartPage.querySelector('#ba_attr_terms');
      if (termsAttribute) {
        termsAttribute.value = termsAreAccepted() ? 'Yes' : '';
        attributes['Terms Accepted'] = termsAttribute.value;
      }
      if (cancellationCheckbox) {
        attributes['Cancellation & Billing Policy'] = cancellationCheckbox.checked ? 'Yes' : '';
      }

      try {
        var company = window.localStorage.getItem('ba_company');
        if (company) attributes.company = company;
      } catch (error) {
        // Checkout should still work when browser storage is unavailable.
      }
      return attributes;
    }

    function saveAttributes(attributes) {
      var snapshot = Object.assign({}, attributes);
      saveQueue = saveQueue.catch(function () {}).then(function () {
        return fetch(cartUpdateUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({attributes: snapshot})
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart attributes could not be saved.');
          return response.json();
        });
      });
      return saveQueue;
    }

    function saveProgress(showConfirmation) {
      if (!questionnaire) return Promise.resolve();
      setSaveStatus('Saving…', false);
      return saveAttributes(collectQuestionnaireAttributes()).then(function () {
        setSaveStatus(showConfirmation ? 'Progress saved.' : '', false);
      }).catch(function (error) {
        setSaveStatus('We could not save your answers. Please check your connection and try again.', true);
        throw error;
      });
    }

    function queueProgressSave() {
      if (!questionnaire) return;
      window.clearTimeout(saveTimer);
      saveTimer = window.setTimeout(function () {
        saveProgress(false).catch(function () {});
      }, SAVE_DELAY);
    }

    function markQuestionnaireIncomplete() {
      if (completedInput) completedInput.value = '';
      if (timestampInput) timestampInput.value = '';
      if (requiresReviewInput) requiresReviewInput.value = hasYesAnswers() ? 'Yes' : 'No';
    }

    function setBusy(busy) {
      isSaving = busy;
      [backButton, nextButton, finishButton].forEach(function (button) {
        if (button) button.disabled = busy;
      });
      updateCheckoutState();
    }

    function openQuestionnaire(event) {
      if (!questionnaire) return;
      opener = event && event.currentTarget ? event.currentTarget : document.activeElement;
      questions.forEach(setQuestionDetailsState);
      updateProgress();
      renderReview();
      showStep(questionnaireIsCompleted() || allQuestionsValid() ? 'review' : firstIncompleteStep());

      if (typeof questionnaire.showModal === 'function') {
        questionnaire.showModal();
      } else {
        questionnaire.setAttribute('open', '');
      }
      document.documentElement.classList.add('ba-questionnaire-open');
      var title = questionnaire.querySelector('#ba-questionnaire-title');
      if (title) title.focus();
    }

    function closeQuestionnaire() {
      if (!questionnaire) return;
      if (typeof questionnaire.close === 'function') {
        questionnaire.close();
      } else {
        questionnaire.removeAttribute('open');
        handleDialogClosed();
      }
    }

    function handleDialogClosed() {
      document.documentElement.classList.remove('ba-questionnaire-open');
      updatePanelStatus();
      updateCheckoutState();
      if (opener && typeof opener.focus === 'function') opener.focus();
    }

    function handleQuestionnaireChange(event) {
      var question = event.target.closest('[data-ba-question]');
      if (!question) return;
      setQuestionDetailsState(question);
      setQuestionValidityUi(question, questionIsValid(question));
      markQuestionnaireIncomplete();
      updateProgress();
      updatePanelStatus();
      updateCheckoutState();
      queueProgressSave();
    }

    function handleQuestionnaireInput(event) {
      if (!event.target.matches('textarea')) return;
      var question = event.target.closest('[data-ba-question]');
      if (!question) return;
      setQuestionValidityUi(question, questionIsValid(question));
      markQuestionnaireIncomplete();
      updatePanelStatus();
      updateCheckoutState();
      queueProgressSave();
    }

    function handleNext() {
      var stepQuestions = questionsForStep(currentStep);
      if (!validateQuestions(stepQuestions, true)) return;

      setBusy(true);
      saveProgress(true).then(function () {
        if (currentStep === '3') {
          renderReview();
          showStep('review');
        } else {
          showStep(String(parseInt(currentStep, 10) + 1));
        }
      }).catch(function () {
        setError('Your progress could not be saved. Please try again before continuing.', true);
      }).finally(function () {
        setBusy(false);
      });
    }

    function handleBack() {
      if (currentStep === 'review') {
        showStep('3');
      } else {
        showStep(String(Math.max(1, parseInt(currentStep, 10) - 1)));
      }
    }

    function handleFinish() {
      if (!validateQuestions(questions, false)) {
        var incompleteStep = firstIncompleteStep();
        showStep(incompleteStep);
        validateQuestions(questionsForStep(incompleteStep), true);
        return;
      }

      window.clearTimeout(saveTimer);
      if (completedInput) completedInput.value = 'Yes';
      if (requiresReviewInput) requiresReviewInput.value = hasYesAnswers() ? 'Yes' : 'No';
      if (timestampInput) timestampInput.value = new Date().toISOString();
      setBusy(true);
      setSaveStatus('Saving your answers…', false);

      saveAttributes(collectQuestionnaireAttributes()).then(function () {
        setSaveStatus('Answers saved.', false);
        updatePanelStatus();
        closeQuestionnaire();
      }).catch(function () {
        if (completedInput) completedInput.value = '';
        if (timestampInput) timestampInput.value = '';
        setSaveStatus('We could not save your answers. Please check your connection and try again.', true);
        setError('Your answers have not been saved yet. Please try again.', true);
      }).finally(function () {
        setBusy(false);
      });
    }

    function focusRequiredArea() {
      if (!questionnaireIsCompleted() && healthPanel) {
        healthPanel.scrollIntoView({behavior: 'smooth', block: 'center'});
        healthPanel.classList.remove('ba-health-panel--attention');
        window.requestAnimationFrame(function () {
          healthPanel.classList.add('ba-health-panel--attention');
        });
        var openButton = healthPanel.querySelector('[data-ba-questionnaire-open]');
        if (openButton) openButton.focus();
      } else if (!termsAreAccepted() && termsCheckbox) {
        termsCheckbox.focus();
      } else if (!cancellationIsAccepted() && cancellationCheckbox) {
        cancellationCheckbox.focus();
      }
    }

    function startCheckout(trigger) {
      if (!checkoutIsAllowed()) {
        updateCheckoutState();
        focusRequiredArea();
        return;
      }

      window.clearTimeout(saveTimer);
      setBusy(true);
      if (primaryCheckout) {
        primaryCheckout.classList.add('is-loading');
        primaryCheckout.setAttribute('aria-busy', 'true');
      }

      saveAttributes(collectCheckoutAttributes()).then(function () {
        window.location.assign(checkoutUrl());
      }).catch(function () {
        setBusy(false);
        if (primaryCheckout) {
          primaryCheckout.classList.remove('is-loading');
          primaryCheckout.removeAttribute('aria-busy');
        }
        if (checkoutMessage) {
          checkoutMessage.textContent = 'We could not save your information. Please check your connection and try checkout again.';
          checkoutMessage.classList.add('is-expanded');
          checkoutMessage.setAttribute('role', 'alert');
          checkoutMessage.focus && checkoutMessage.focus();
        }
      });
    }

    openButtons.forEach(function (button) {
      button.addEventListener('click', openQuestionnaire);
    });
    if (closeButton) closeButton.addEventListener('click', closeQuestionnaire);
    if (backButton) backButton.addEventListener('click', handleBack);
    if (nextButton) nextButton.addEventListener('click', handleNext);
    if (finishButton) finishButton.addEventListener('click', handleFinish);

    if (questionnaire) {
      questionnaire.addEventListener('change', handleQuestionnaireChange);
      questionnaire.addEventListener('input', handleQuestionnaireInput);
      questionnaire.addEventListener('close', handleDialogClosed);
      questionnaire.addEventListener('click', function (event) {
        if (event.target === questionnaire) closeQuestionnaire();
      });
      questions.forEach(setQuestionDetailsState);
    }

    cartPage.addEventListener('change', function (event) {
      if (event.target === termsCheckbox || event.target === cancellationCheckbox) {
        var termsAttribute = cartPage.querySelector('#ba_attr_terms');
        if (termsAttribute) termsAttribute.value = termsAreAccepted() ? 'Yes' : '';
        window.requestAnimationFrame(updateCheckoutState);
      }
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target && event.target.closest('[name="checkout"], a[href*="/checkout"], .shopify-payment-button__button');
      if (!trigger || !cartPage.contains(trigger)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      startCheckout(trigger);
    }, true);

    if (cartForm) {
      cartForm.addEventListener('submit', function (event) {
        var submitter = event.submitter;
        if (!submitter || submitter.name !== 'checkout') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        startCheckout(submitter);
      }, true);
    }

    document.addEventListener('theme:cart:added', function () {
      window.requestAnimationFrame(function () {
        if (healthPanel) healthPanel.hidden = !questionnaireIsRequired();
        updateCheckoutState();
      });
    });

    if (completedInput && completedInput.value === 'Yes' && (!allQuestionsValid() || !timestampInput || !timestampInput.value)) {
      completedInput.value = '';
      if (timestampInput) timestampInput.value = '';
    }

    if (requiresReviewInput) requiresReviewInput.value = hasYesAnswers() ? 'Yes' : 'No';

    updateProgress();
    updatePanelStatus();
    updateCheckoutState();
    window.requestAnimationFrame(updateCheckoutState);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartQuestionnaire);
  } else {
    initCartQuestionnaire();
  }
})();
